export default __webpack_public_path__ + "static/media/WStore_FoodCredit.78c8f713.png";